import { useTheme } from '@mui/material'
import {
  Background,
  Container,
  LeftContainer,
  SettingsButton,
  SettingsText,
  TextContainer,
} from '../../settings-details.styles'
import EditTaxSettingsDialog from '../../../../../components/edit-tax-settings-dialog/edit-tax-settings-dialog.component'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'

const SettingsTax = () => {
  const theme = useTheme()

  const [open, setOpen] = useState(false)

  const user = useSelector((state: RootState) => state.auth.user)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Background theme={theme}>
        <Container>
          <LeftContainer>
            <TextContainer>
              <SettingsText>Tax Name: </SettingsText>
              <SettingsText variant="bold">{user?.taxName ?? ''}</SettingsText>
            </TextContainer>
            <TextContainer>
              <SettingsText>Tax Number: </SettingsText>
              <SettingsText variant="bold">{user?.taxNumber ?? ''}</SettingsText>
            </TextContainer>
            <TextContainer>
              <SettingsText>Tax Percentage: </SettingsText>
              <SettingsText variant="bold">
                {user?.taxPercentage != null ? `${user.taxPercentage}%` : ''}
              </SettingsText>
            </TextContainer>
          </LeftContainer>
          <SettingsButton variant="contained" size="small" onClick={handleOpen}>
            Edit Tax
          </SettingsButton>
        </Container>
      </Background>
      <EditTaxSettingsDialog open={open} handleClose={handleClose} />
    </>
  )
}

export default SettingsTax
